<router-outlet></router-outlet>
<app-maintenance-page
  *ngIf="showMaintenancePage"
  [timeFrom]="timeFrom"
  [timeTo]="timeTo">
</app-maintenance-page>
